"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var context_1 = require("../context");

exports.default = function (onSuccess) {
  var xya = context_1.useXyAccountContext();

  var _a = react_1.useState(false),
      loading = _a[0],
      setLoading = _a[1];

  var _b = react_1.useState(''),
      error = _b[0],
      setError = _b[1];

  var _c = react_1.useState(false),
      emailDoesNotExist = _c[0],
      setEmailDoesNotExist = _c[1];

  var signIn = function signIn(email, password) {
    setLoading(true);
    setError('');
    Promise.resolve().then(function () {
      return xya.signIn(email, password);
    }).then(function () {
      setLoading(false);
      onSuccess();
    }).catch(function (err) {
      setLoading(false);
      setError(err.message);

      if (err['code'] === 'auth/user-not-found') {
        setEmailDoesNotExist(true);
      }
    });
  };

  return {
    loading: loading,
    error: error,
    signIn: signIn,
    emailDoesNotExist: emailDoesNotExist
  };
};